import {
  Button,
  Grid,
  TextField,
  OutlinedInput,
  ListItemText,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Modal,
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
  Divider,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../../mui/LoadingOverlay";
import { Updateuserdata } from "../../api/apiAdmin";
import { useDispatch } from "react-redux";
import { selectnodess } from "../../redux/nodesSlice";
import { updateusers } from "../../redux/usersSlice";
import CountryAutocomplete from "../CountryAutocomplete";
import { selectgroups } from "../../redux/businessSlice";
import { useSelector } from "react-redux";
import { Visibility, VisibilityOff } from "@mui/icons-material";
const organizationPermissions = [
  { label: "Delete Organisation", value: "deleteOrganization" },
  { label: "Edit Organisation", value: "editOrganization" },
  { label: "Add Organisation", value: "addOrganization" },
  { label: "View All Organisation", value: "viewAllOrganization" },
  { label: "Specific Companies", value: "viewSpecificCompanies" },
  {
    label: "View Country Business Type Organisation",
    value: "viewCountryBusinessTypeOrganization",
  },
  {
    label: "View Business Type Organisation",
    value: "viewBusinessTypeOrganization",
  },
];
const userPermissions = [
  { label: "Show User", value: "showUser" },
  { label: "Edit User", value: "editUser" },
  { label: "Delete User", value: "deleteUser" },
];
export function UpdateuserModal({ open, onClose, data, refetchUserList }) {
  const navigate = useNavigate();
  // console.log("data", data);
  const [loading, setLoading] = useState(false);
  const [openPermissionsModal, setOpenPermissionsModal] = useState(false);
  const [userData, setUserData] = useState(data);
  const businesses = useSelector(selectgroups);
  const allorganization = useSelector(selectnodess);
  const [errors, setErrors] = useState({});
  const [selectedPermissions, setSelectedPermissions] = useState(
    data.permissions || {}
  );
  const dispatch = useDispatch();
  const [selected, setSelected] = useState([]);
  const [selectedorgs, setSelectedOrgs] = useState([]);
  // console.log("companies", selected);
  const [selectedValues, setSelectedValues] = useState([]);
  const [showPassword, setShowPassword] = useState(false); // 👈 for toggling password visibility

  // console.log("business", selectedValues);
  const groups = useSelector(selectgroups);
  useEffect(() => {
    setUserData(data);
    setSelectedValues(data.businesses);
    setSelectedOrgs(data.companies);
    setSelectedPermissions(data.permissions || {});
  }, [data]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUserData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleChangeStatus = (e) => {
    const { name, value } = e.target;
    let status = value === "Deleted" ? true : false;   
    setUserData((prevData) => ({
      ...prevData,
      [name]: status,
    }));
  };
  // console.log("selectVlies", selectedValues);
  useEffect(() => {
    // Filter the organizations only when `allorganization` or `businesses` change
    if (allorganization && businesses) {
      const filtered = allorganization?.filter((item) =>
        selectedValues?.includes(item?.data?.BusinessGroup)
      );
      // console.log("filtered", filtered);
      setSelected(filtered);
    } else {
      setSelected([]); // Handle cases where no organizations match
    }
  }, [allorganization, businesses, selectedValues]);

  useEffect(() => {
    if (allorganization?.length > 0 && selectedorgs?.length > 0) {
      const filteredSelected = allorganization?.filter((item) =>
        selectedorgs?.includes(item?._id)
      );



      const filterbussinesscompanies = filteredSelected?.filter((item) =>
        selectedValues.includes(item?.data?.BusinessGroup)
      );
      const allorgdata = filterbussinesscompanies?.map((i) => {
        return i._id;
      });
      setSelectedOrgs(allorgdata);
    }
  }, [selectedValues]);

  const handlePermissionChange = (event) => {
    const { value, checked } = event.target;
    //// console.log(value, checked);
    //// console.log("Before change:", selectedPermissions);
    if (
      [
        "viewAllOrganization",
        "viewSpecificCompanies",
        "viewCountryBusinessTypeOrganization",
        "viewBusinessTypeOrganization",
      ].includes(value)
    ) {
      setSelectedPermissions((prev) => {
        const updatedPermissions = {
          ...prev,
          viewAllOrganization: false,
          viewSpecificCompanies: false,
          viewCountryBusinessTypeOrganization: false,
          viewBusinessTypeOrganization: false,
          [value]: checked,
        };
        //// console.log("Updated permissions:", updatedPermissions);
        return updatedPermissions;
      });
    } else {
      setSelectedPermissions((prev) => {
        const updatedPermissions = {
          ...prev,
          [value]: checked,
        };
        //// console.log("Updated permissions:", updatedPermissions);
        return updatedPermissions;
      });
    }
  };
  const validateInput = () => {
    const errorObject = {};
    if (!userData.firstName) errorObject.firstName = "First Name is required";
    if (!userData.lastName) errorObject.lastName = "Last Name is required";
    if (!userData.email) errorObject.email = "Email is required";
    if (!userData.businessType)
      errorObject.businessType = "Business Type is required";
    if (!userData.userRole) errorObject.userRole = "User Role is required";
    if (!userData.userCountry)
      errorObject.userCountry = "User Country is required";
    setErrors(errorObject);
    return Object.keys(errorObject).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateInput()) {
      toast.error("Please fix the errors in the form.");
      return;
    }
    try {
      setLoading(true);
      const response = await Updateuserdata(userData._id, {
        firstName: userData.firstName,
        lastName: userData.lastName,
        businessType: userData.businessType,
        userRole: userData.userRole,
        email: userData.email,
        password: userData.password,
        companies: selectedorgs,
        businesses: selectedValues,
        permissions: selectedPermissions,
        userCountry: userData.userCountry,
        isDeleted: userData.isDeleted,
      });

      if (response && response.status === 200) {
        dispatch(updateusers(response.data.data));
        toast.success("User updated successfully");
        setLoading(false);
        // Refetch user list if refetch function is provided
        if (refetchUserList) {
          await refetchUserList();
        }
        onClose();
        navigate("/admin/userList");
      } else {
        toast.error("Failed to update user");
        setLoading(false);
      }
    } catch (error) {
      toast.error("Failed to update user");
      setLoading(false);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="update-user-modal-title"
        aria-describedby="update-user-modal-description"
        BackdropProps={{
          style: { zIndex: 0 }, // Set a lower z-index for the backdrop
        }}
        sx={{ zIndex: 1000 }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 600,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography
            variant="h6"
            className="mb-4"
            id="update-user-modal-title"
          >
            Update User
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                label="First Name"
                name="firstName"
                value={userData.firstName}
                onChange={handleChange}
                error={Boolean(errors.firstName)}
                fullWidth
                helperText={errors.firstName}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Last Name"
                name="lastName"
                value={userData.lastName}
                onChange={handleChange}
                error={Boolean(errors.lastName)}
                fullWidth
                helperText={errors.lastName}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Email"
                name="email"
                type="email"
                value={userData.email}
                onChange={handleChange}
                error={Boolean(errors.email)}
                fullWidth
                helperText={errors.email}
                variant="outlined"
                size="small"
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                error={Boolean(errors.businessType)}
              >
                <InputLabel>Business Group</InputLabel>
                <Select
                  name="businessType"
                  value={userData.businessType}
                  onChange={handleChange}
                  label="Business Group"
                >
                  {groups?.map((item, index) => {
                    return (
                      <MenuItem key={index} value={item._id}>
                        {item.businessNature}
                      </MenuItem>
                    );
                  })}
                </Select>
                {errors.businessType && (
                  <small style={{ color: "red" }}>{errors.businessType}</small>
                )}
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <CountryAutocomplete
                userData={userData}
                setUserData={setUserData}
                errors={errors}
              />
            </Grid>
            {/* 👇 Password Field with Eye Icon */}
            {!userData?.azureId &&

              <Grid item xs={12}>
                <TextField
                  label="Password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  value={userData.password}
                  onChange={handleChange}
                  error={Boolean(errors.password)}
                  helperText={errors.password}
                  fullWidth
                  variant="outlined"
                  size="small"
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>}
            <Grid item xs={12}>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                error={Boolean(errors.userRole)}
              >
                <InputLabel>Status</InputLabel>
                <Select
                  name="isDeleted"
                  value={userData.isDeleted ? "Deleted" : "Active"}
                  onChange={handleChangeStatus}
                  label="Status"
                >
                  <MenuItem value={"Deleted"}>Deleted</MenuItem>
                  <MenuItem value={"Active"}>Active</MenuItem>
                </Select>
                {errors.status && (
                  <p style={{ color: "red" }}>{errors.status}</p>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                error={Boolean(errors.userRole)}
              >
                <InputLabel>User Role</InputLabel>
                <Select
                  name="userRole"
                  value={userData.userRole}
                  onChange={handleChange}
                  label="User Role"
                >
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="User">User</MenuItem>
                </Select>
                {errors.userRole && (
                  <p style={{ color: "red" }}>{errors.userRole}</p>
                )}
              </FormControl>
            </Grid>
            <Grid
              item
              xs={12}
              container
              justifyContent="flex-between"
              spacing={2}
            >
              {userData.userRole === "User" && (
                <Grid item>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => setOpenPermissionsModal(true)}
                  >
                    Update Permissions
                  </Button>
                </Grid>
              )}
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={handleSubmit}
                >
                  Update
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <Modal
        open={openPermissionsModal}
        onClose={() => setOpenPermissionsModal(false)}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "70%",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          <Typography variant="h6" component="h2">
            Assign Permissions
          </Typography>
          <Divider />
          <Box mt={2}>
            <Typography variant="subtitle1" className="fw-bold">
              Organization Permissions
            </Typography>
            {organizationPermissions?.map((permission) => (
              <FormControlLabel
                key={permission.value}
                control={
                  <Checkbox
                    checked={selectedPermissions[permission.value]}
                    onChange={handlePermissionChange}
                    value={permission.value}
                  />
                }
                label={permission.label}
              />
            ))}
            <Box display="flex" flexWrap="wrap" gap={{ xs: 1, sm: 2 }}>
              {/* business */}
              <FormControl
                sx={{ width: 200 }}
                disabled={!selectedPermissions.viewSpecificCompanies}
              >
                <InputLabel>Select Business</InputLabel>
                <Select
                  multiple
                  value={selectedValues} // State stores IDs of selected businesses
                  onChange={(event) => {
                    const value = event.target.value;
                    if (value.includes("all")) {
                      // If "Select All" is clicked, toggle all businesses
                      setSelectedValues(
                        selectedValues.length === businesses.length
                          ? []
                          : businesses?.map((biz) => biz._id) // Store IDs
                      );
                    } else {
                      // Handle individual selections
                      setSelectedValues(value);
                    }
                  }}
                  input={<OutlinedInput label="All Business" />}
                  renderValue={
                    (selected) =>
                      businesses
                        ?.filter((biz) => selected?.includes(biz._id)) // Filter businesses by selected IDs
                        ?.map((biz) => biz.businessNature) // Map to their names
                        .join(", ") // Display names in input
                  }
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200, // Limit height for scrollable menu
                        overflow: "auto", // Enable scrolling
                      },
                    },
                  }}
                >
                  {/* "Select All" Checkbox */}
                  <MenuItem value="all">
                    <Checkbox
                      checked={selectedValues.length === businesses.length}
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>
                  {/* Individual Business Checkboxes */}
                  {businesses?.map((option) => (
                    <MenuItem key={option._id} value={option._id}>
                      {" "}
                      {/* Use ID as value */}
                      <Checkbox
                        checked={selectedValues?.includes(option._id)}
                      />{" "}
                      {/* Check by ID */}
                      <ListItemText primary={option?.businessNature} />{" "}
                      {/* Display name */}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              {/* companies */}
              <FormControl
                sx={{ width: 200 }}
                disabled={!selectedPermissions.viewSpecificCompanies}
              >
                <InputLabel>Select Companies</InputLabel>
                <Select
                  multiple
                  value={selectedorgs} // Holds IDs of selected companies
                  onChange={(event) => {
                    const value = event.target.value;

                    if (value.includes("all")) {
                      // Handle "Select All" logic
                      if (selectedorgs.length === selected.length) {
                        // If all options are already selected, deselect all
                        setSelectedOrgs([]);
                      } else {
                        // Select all options
                        const allIds = selected?.map((item) => item._id);
                        setSelectedOrgs(allIds);
                      }
                    } else {
                      // Handle individual selection/deselection
                      setSelectedOrgs(value);
                    }
                  }}
                  input={<OutlinedInput label="All Companies" />}
                  renderValue={(selectedIds) => {
                    // Display selected company names in the input
                    return selected
                      .filter((option) => selectedIds.includes(option._id))
                      ?.map((option) => option?.data?.companyName)
                      .join(", ");
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 200, // Limit height for scrollable menu
                        overflow: "auto", // Enable scrolling
                      },
                    },
                  }}
                >
                  {/* "Select All" Checkbox */}
                  <MenuItem value="all">
                    <Checkbox
                      checked={selectedorgs.length === selected.length}
                    />
                    <ListItemText primary="Select All" />
                  </MenuItem>

                  {/* Individual Company Checkboxes */}
                  {selected?.map((option) => (
                    <MenuItem key={option?._id} value={option?._id}>
                      <Checkbox checked={selectedorgs.includes(option?._id)} />
                      <ListItemText primary={option?.data?.companyName} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
          <Divider />
          <Box mt={2}>
            <Typography variant="subtitle1" className="fw-bold">
              User Permissions
            </Typography>
            {userPermissions?.map((permission) => (
              <FormControlLabel
                key={permission.value}
                control={
                  <Checkbox
                    checked={selectedPermissions[permission.value]}
                    onChange={handlePermissionChange}
                    value={permission.value}
                  />
                }
                label={permission.label}
              />
            ))}
          </Box>
          <Box mt={2} textAlign="right">
            <Button onClick={() => setOpenPermissionsModal(false)}>
              Close
            </Button>
            <Button onClick={handleSubmit} variant="contained" sx={{ ml: 2 }}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* <Modal
                open={openPermissionsModal}
                onClose={() => setOpenPermissionsModal(false)}
                aria-labelledby="permissions-modal-title"
                aria-describedby="permissions-modal-description"
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: "80%",
                        bgcolor: 'background.paper',
                        border: '2px solid #000',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Typography variant="h6" id="permissions-modal-title">Assign Permissions</Typography>
                    <Divider />
                    <Box mt={2}>
                        <Typography variant="subtitle1" className="fw-bold">Organization Permissions</Typography>
                        {organizationPermissions?.map((permission) => (
                            <FormControlLabel
                                key={permission.value}
                                control={
                                    <Checkbox
                                        checked={!!selectedPermissions[permission.value]}
                                        onChange={handlePermissionChange}
                                        name={permission.value}
                                    />
                                }
                                label={permission.label}
                            />
                        ))}
                    </Box>
                    <Box mt={2}>
                        <Typography variant="subtitle1" className="fw-bold">User Permissions</Typography>
                        {userPermissions?.map((permission) => (
                            <FormControlLabel
                                key={permission.value}
                                control={
                                    <Checkbox
                                        checked={!!selectedPermissions[permission.value]}
                                        onChange={handlePermissionChange}
                                        name={permission.value}
                                    />
                                }
                                label={permission.label}
                            />
                        ))}
                    </Box>
                    <Box mt={2} display="flex" justifyContent="flex-end">
                        <Button variant="contained" color="primary" onClick={() => setOpenPermissionsModal(false)}>
                            Save Permissions
                        </Button>
                    </Box>
                </Box>
            </Modal> */}

      <LoadingOverlay open={loading} />
    </>
  );
}
